import React, { useState, useContext, useEffect } from 'react'
import RegisterProductHeader from './RegisterProductHeader'
import RegisterProductInner from './RegisterProductInner'
import RegisterProductFooter from './RegisterProductFooter'
import { appContext } from '../../../App'
import { getProductsList, getProductById, saveProduct, getWarehouses } from '../ProductsFunctions'

export const registerProductControllerContext = React.createContext()

function useRegisterProductController({product_id}) {
  const app = useContext(appContext)
  const initProduct = {
    name: '',
    brand: '',
    description: '',
    classification: '',
    status: 'Active',
    units: []
  }
  const [product, setProduct] = useState(null)
  const [productsList, setProductsList] = useState([])

  const updateUnit = (unit, unitID) => {
    let prevItemDescription, curItemDescription
    let unit_to_update = product.units.find(unit => unit.id === unitID)

    if (!unitID)
      // If unitID is not define it means it's an add
      // Put new unit at the bottom
      setProduct({...product, units: [...product.units, unit]})
    else {
      // It's an update
      if (unit.unit_type === 'Base') {
        unit.unit_content = ''
      }
      prevItemDescription = unit_to_update.description
      curItemDescription = unit.description

      product.units.forEach((u, i) => {
        if (u.id !== unitID) {
          product.units[i].description = u.description.replace(prevItemDescription, curItemDescription)
          product.units[i].unit_content = u.unit_content.replace(prevItemDescription, curItemDescription)
        } else {
          product.units[i] = unit
        }
      })

      setProduct({...product, units: [...product.units]});
    }
  }

  const findBarcode = async (barcode) => {
    let found = null
    const products_list = await getProductsList(app)
    if (products_list) {
      for (let product of products_list) {
        const found_product = (product.units.find(unit => unit.id === barcode))
        if (found_product) found = found_product
      }
    }
    return (found)
  }

  
  useEffect(() => {
    const init = async () => {
      const products_list = await getProductsList(app)
      setProductsList(products_list)
      setProduct(product_id ? await getProductById(app, product_id) : initProduct)
    }

    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ({
    product: [product, setProduct],
    saveProduct,
    getWarehouses,
    productsList,
    updateUnit,
    findBarcode
  })
}

function RegisterProductController(props) {
  const registerProductController = useRegisterProductController(props)

  if (registerProductController.product[0]) {
    return (
      <React.Fragment>
        <registerProductControllerContext.Provider value={ registerProductController }>
          <RegisterProductHeader />
          <RegisterProductInner />
          <RegisterProductFooter />
        </registerProductControllerContext.Provider>
      </React.Fragment>
    )
  } else return null
}

export default React.memo(RegisterProductController)